import { get } from "@/helpers/api.helper";
import { SCHOOL_CALENDAR_PUBLIC } from "@/constants/urls";
import { SchoolCalendarItem } from "@/models/api/schoolCalendar";

/**
 * Everything the school has put on its calendar (events, class events, holidays,
 * examinations) between two dates (yyyy-MM-dd, inclusive). Public - no login.
 */
export const getPublicSchoolCalendar = async (from: string, to: string): Promise<SchoolCalendarItem[]> => {
  const response = await get<{ success: boolean; data: SchoolCalendarItem[] }>(SCHOOL_CALENDAR_PUBLIC(from, to));
  return Array.isArray(response?.data) ? response.data : [];
};
